const THEME_LIGHT = {
  argument: [245, 135, 31],
  boolean: [66, 113, 174],
  comment: [117, 113, 94],
  keyword: [200, 40, 41],
  name: [201, 159, 0],
  number: [101, 67, 133],
  plain: [128, 128, 128],
  property: [32, 123, 129],
  string: [113, 140, 0],
};

export default THEME_LIGHT;
